import { render } from "./recover_pwd.vue?vue&type=template&id=d8deff5a&scoped=true"
import script from "./recover_pwd.vue?vue&type=script&lang=js"
export * from "./recover_pwd.vue?vue&type=script&lang=js"

import "./recover_pwd.vue?vue&type=style&index=0&id=d8deff5a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8deff5a"]])

export default __exports__